import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAdobephotoshopComponent } from './simple-icons-adobephotoshop.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAdobephotoshopComponent ],
    exports:      [ SimpleIconsAdobephotoshopComponent ],
    bootstrap:    []
})
export class SimpleIconsAdobephotoshopModule {}
